import { useEffect, useState } from "react";
import { Get } from "../../../../Request";

export const useNesdata = () => {
  const [loadingData, setLoadingData] = useState(true);
  const [nesdata, setnNesdata] = useState({});
  const getNesdata = needkey => {
    setLoadingData(true);
    Get({
      url: "/data/need",
      data: { needkey: needkey },
    }).then(res => {
      setnNesdata(res);
      setLoadingData(false);
    });
  };
  const get = key => {
    return nesdata[key];
  };

  return {
    loadingData,
    nesdata,
    get,
    getNesdata,
  };
};
